import { Services } from '@spectorasoftware/homegauge-services';
import UnauthenticatedErrorHandler from './unauthenticated-error-handler';

const {
  AppointmentService,
  AppointmentCustomFieldsService,
  AuthService,
  CompanyService,
  // FeatureService,
  InspectionServicesService,
  InvoiceService,
  PersonService,
} = Services;

class ApiContainer {
  constructor() {
    this.appointmentService = null;
    this.appointmentCustomFieldsService = null;
    this.authService = null;
    this.companyService = null;
    // this.featureService = null;
    this.inspectionServicesService = null;
    this.invoiceService = null;
    this.personService = null;
  }

  init(router, store) {
    const API_AUTH_URL = process.env.VUE_APP_AUTH_SVC_URL;
    const API_BASIC_USER = process.env.VUE_APP_AUTH_SVC_BASIC_USER;
    const API_URL = process.env.VUE_APP_API_SVC_URL;
    const CLASSIC_URL = process.env.VUE_APP_HG_CLASSIC_URL;

    const serviceConfig = {
      errorHandler: async apiError => {
        await UnauthenticatedErrorHandler(apiError, router, store);
      },
    };

    this.authService = new AuthService(API_AUTH_URL, { classicUrl: CLASSIC_URL }, API_BASIC_USER);

    this.appointmentService = new AppointmentService(API_URL, serviceConfig);
    this.appointmentCustomFieldsService = new AppointmentCustomFieldsService(
      API_URL,
      serviceConfig,
    );
    this.companyService = new CompanyService(API_URL, serviceConfig);
    // this.featureService = new FeatureService(API_URL, serviceConfig);
    this.inspectionServicesService = new InspectionServicesService(API_URL, serviceConfig);
    this.invoiceService = new InvoiceService(API_URL, serviceConfig);
    this.personService = new PersonService(API_URL, serviceConfig);
  }
}

export { ApiContainer };
export default new ApiContainer();
